import {Currency} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";

export const allCurrencyOptions: SelectOption<Currency>[] = [
    {
        label: "GBP (£)",
        value: Currency.Gbp
    },
    {
        label: "USD ($)",
        value: Currency.Usd
    },
    {
        label: "EUR (€)",
        value: Currency.Eur
    },
    {
        label: "JPY (¥)",
        value: Currency.Jpy
    },
    {
        label: "AED (AED)",
        value: Currency.Aed
    },
    {
        label: "CAD ($)",
        value: Currency.Cad
    }
]

export const getCurrencyName = (currency: Currency) => {
    const option = allCurrencyOptions.filter(o => o.value === currency)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle currency: ${currency} correctly`)
}

export const currencyToIsoCode = (currency?: Currency): string => {
    switch (currency) {
        case Currency.Usd:
            return "USD";
        case Currency.Eur:
            return "EUR";
        case Currency.Jpy:
            return "JPY";
        case Currency.Aed:
            return "AED";
        case Currency.Cad:
            return "CAD";
        case Currency.Gbp:
        default:
            return "GBP";
    }
}
